import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import de from "vuetify/lib/locale/de";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#7b0000',
        secondary: '#737373',

      },
      dark: {
        primary: '#7b0000',
        secondary: '#424242'
      },
    },
  },
  lang: {
    locales: { de },
    current: "de",
  },
});

